// import { IdentifiedItem } from "interfaces/index";
// import { ProductSalesChartAPI } from "./chart";
import { IProductSalesEntry } from "./interfaces";
import { IdentifiedItem } from "interfaces/index";
import { appStateService, store } from "App";
import { actions } from "redux/reducers/dashboard/dashboardGraphDataReducer";
import { DashboardGraphDataSelectors } from "redux/selectors/dashboard/graph/dashboardGraphDataSelectors";
import { chartIds } from "components/page/home/dashboard/graphs/chart.ids";
import { IChartConfig } from "components/page/dashboard/graph/shared";

export declare type ChartDataAPITypes = IProductSalesEntry | IdentifiedItem;

/**
 * The API service layer for the chart data gathering and configuration.
 */
export class ChartAPIService {
	// private _productSalesChart: () => ProductSalesChartAPI = () => {
	// 	return appStateService.company.reports.monthly.productSales.get();
	// };

	constructor() {}

	// async getChartDataById<ChartEntryType extends ChartDataAPITypes>(
	// 	chartId: string,
	// 	onUpdated: (data: ChartEntryType[]) => void
	// ): Promise<ChartEntryType[]> {
	// 	switch (chartId) {
	// 		case chartIds.productSales:
	// 			return this._productSalesChart().getChartData() as any;
	// 		default:
	// 			return [];
	// 	}
	// }

	/**
	 * Stores the graph data by its ID.
	 *
	 * @param chartId
	 * @param data
	 */
	storeGraphDataById<ChartEntryType extends ChartDataAPITypes>(
		chartId: string,
		data: ChartEntryType[]
	): void {
		store.dispatch(actions.setDataById({ graphId: chartId, data }));
	}

	/**
	 * Retrieves the graph data by its ID.
	 *
	 * @param chartId
	 * @returns
	 */
	getGraphDataById<ChartEntryType extends ChartDataAPITypes>(
		chartId: string
	): ChartEntryType[] {
		const state = store.getState();
		return DashboardGraphDataSelectors.getGraphDataById(state, chartId);
	}

	/**
	 * Retrieves the graph config by its ID.
	 *
	 * @param chartId
	 * @returns
	 */
	getGraphConfigById(chartId: string): any {
		const state = store.getState();
		return DashboardGraphDataSelectors.getGraphConfigById(state, chartId);
	}

	/**
	 * Sets the Graph configuration based on an ID
	 *
	 * @param chartId
	 * @param graphColumnConfig
	 */
	setGraphConfigById(chartId: string) {
		store.dispatch(
			actions.setActiveConfigById({
				graphId: chartId
			})
		);
	}

	/**
	 * Sets the active chart config by its ID.
	 *
	 * @param chartId
	 * @param columns
	 * @returns
	 */
	setActiveChart(chartId: string, columns: any[]): void {
		store.dispatch(actions.setActiveChart({ chartId, columns }));
	}

	/**
	 * Resets a Graph Data by its given ID.
	 *
	 * @param graphId The Graph ID to reset data.
	 */
	resetById(graphId: string) {
		store.dispatch(actions.clearById(graphId));
	}

	// /**
	//  * Gets the active chart.
	//  * @returns
	//  */
	// getActiveChart(): { chartId: string; columns: any[] } {
	//     const state = store.getState();
	//     // return DashboardGraphDataSelectors.getActiveChart(state);
	// }
}
